// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"SubArticlesContainer_ProseMirror__1f8FY","container__loader":"SubArticlesContainer_container__loader__23t1W"};